import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContentRoutingModule } from './content-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ContentFormComponent } from './components/content-form/content-form.component';
import { ContentListComponent } from './components/content-list/content-list.component';
import { ContentManagementComponent } from './pages/content-management/content-management.component';
import { VideoContentComponent } from './pages/video-content/video-content.component';
import { ContentDetailsComponent } from './components/content-details/content-details.component';
import { MatTableModule } from '@angular/material/table';
import { NgProgressModule } from 'ngx-progressbar';
import { AdminModule } from '../../admin/admin.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxLoadingModule } from "ngx-loading";

@NgModule({
  declarations: [
    ContentFormComponent,
    ContentListComponent,
    ContentDetailsComponent,
    ContentManagementComponent,
    VideoContentComponent
  ],
  imports: [
    CommonModule,
    ContentRoutingModule,
    SharedModule,
    MatCardModule,
    MatTabsModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatTableModule,
    NgProgressModule,
    AdminModule,
    MatPaginatorModule,
    NgxLoadingModule.forRoot({})
  ]
})
export class ContentModule { }
